// Beispiel-Breakpoints
const sizes = {
  mobile: '768px',
  tablet: '1024px',
};

export const media = {
  mobile: (styles: TemplateStringsArray, ...args: any[]) => `
    @media (max-width: ${sizes.mobile}) {
      ${String.raw(styles, ...args)}
    }
  `,
  tablet: (styles: TemplateStringsArray, ...args: any[]) => `
    @media (max-width: ${sizes.tablet}) {
      ${String.raw(styles, ...args)}
    }
  `,
};
